import { render, staticRenderFns } from "./studyHome.vue?vue&type=template&id=061fc35d&scoped=true&"
import script from "./studyHome.vue?vue&type=script&lang=js&"
export * from "./studyHome.vue?vue&type=script&lang=js&"
import style0 from "./studyHome.vue?vue&type=style&index=0&id=061fc35d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fc35d",
  null
  
)

export default component.exports